<template>
	<v-overlay :absolute="absolute" :value="value">
		<v-progress-circular indeterminate size="64"></v-progress-circular>
	</v-overlay>
</template>

<script>
	/**
	 * @module OverlayCircular
	 *
	 * @vue-prop {boolean} absolute - Applies 'position: absolute' to the component
	 * @vue-prop {boolean} value - Controls whether the component is visible or hidden
	 */

	export default {
		name: 'OverlayCircular',
		props: {
			absolute: {
				required: true,
				type: Boolean,
			},
			value: {
				required: true,
				type: Boolean,
			},
		},
	};
</script>
